<template>
	<div class="workbench gov_minwidth" >
		<div class="indexcenterpage">
			<leftnav class="fl" mkcode="E" :docutitle="crmuserdata.roleType<3?'管理台':'工作台'"></leftnav>
			<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
				<govheader :show-video="true" :video-type="5"></govheader>
				<div class="index_left_centerpage">
				<div v-if="userdata.token">
					
					<!-- 选择开始 -->
					<div class="workbench_chose oh">
						<!-- <el-select v-model="viewvalue" @change="getworkcount(viewvalue)">
							<el-option v-for="(item,index) in viewoptions" v-if="index > 0 || crmuserdata.roleType < 3"			:key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select> -->
	 
					<!-- 	<el-date-picker v-model="timevalue" type="daterange" range-separator="至"	start-placeholder="开始日期" end-placeholder="结束日期" @change="getworkcount(timevalue,1)">	</el-date-picker>					 
						<span class="chose_save" @click="hassearch=true">查询</span>
						<span class="chose_empty " @click="empty()">清空</span> -->
						 
					</div>
					<!-- 选择结束-->
					<div class="workbench_conbox">
						<!-- 顶部开始 -->
						<div class="workbox_top oh whitebox">
							<!-- 工作台开始 -->
							<div class="work_box oh workbench_left fl">
								<div class="work_title">
									<h3 class="title fl">工作台</h3>
									<el-select v-model="viewvalue" @change="getworkcount(viewvalue)" class="fl">
										<el-option v-for="(item,index) in viewoptions" v-if="index > 0 || crmuserdata.roleType < 3"			:key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
									</div>
								<div class="work_box_left fl">
									<div class="workstatistics flexcss">
										<h4 class="workstatistics_ico" :data="viewvalue">工作统计</h4>
										<div class="workstatistics_num" v-if="viewvalue==2">
											<p>部门：（{{userCount.departmentCount}}）</p>
											<p>人员：（{{userCount.userCount}}）</p>
										</div>
										<div class="workstatistics_more" v-if="viewvalue==2"	@click="routerself('/statisticalAnalysis')">更多</div>
									</div>
									<ul class="work_field">
										<li>关注企业({{worklist.collectEnterprise}})</li>
										<li>跟进企业({{worklist.trackEnterprise}})</li>
										<li>已签约({{worklist.alreadySignied}})</li>
										<li>联系人({{worklist.addContact}})</li>
										<li>关注园区({{worklist.collectPark}})</li>
										<li>意向企业({{worklist.purposeEnterprise}})</li>
										<li>已落地({{worklist.alreadyComplete}})</li>
										<li>暂时搁置（{{worklist.alreadyComplete}}） </li>
									</ul>
								</div>
								<div id="work_box_right" class="fr"></div>
							</div>
							<!-- 工作台结束 -->  
								<!-- 待办 -->
								<div class="needbox workbench_right fr">
									<div class="work_title">
										<h3 class="fl title">{{viewvalue == 1?'我的待办':'部门待办'}}</h3>
										<el-date-picker v-model="todotime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="gettodolist(1)"> 	</el-date-picker>
										<span   v-for="(item,index) in dayarr"		@click="gettodolist(index+2);"	:class="todayopen == (index+2) ?'shortcut_options_cur':'shortcut_options'">{{item}}</span>
										<span class="fr add" @click="addtodoframe = true">添加</span>
									</div>  
									<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" >
										<tr>
											<th>待办时间 </th>
											<th v-show="viewvalue == 2">代办人</th>
											<th>企业名称</th>
											<th>备注</th>
											<th>完成进度</th>
										</tr>
										<!--  v-if="item.managerName == crmuserdata.userName || viewvalue == 2" -->
										<tr v-for="(item,i) in todolist">
											<td>{{item.todoTime}}</td>
											<td v-show="viewvalue == 2">{{item.managerName}}</td>
											<td class="workbench_enterprise_details"	@click="detailrouterto('/workbenchEnterpriseDetails',item.customerId)"	:class="item.stockCode != '' ? 'curp':''">{{item.customerName}}</td>
											<td><span v-show="item.remark !=''">{{item.remark}}</span><span	v-show="item.remark == ''">-</span></td>
											<td><span v-show="item.todoStatus==0">待完成</span><span		v-show="item.todoStatus==1">已完成</span></td>
										</tr>
									</table>
									<!-- 添加待办弹框 -->
									<div class="framebgbox" v-show="addtodoframe">
										<div class="framebox">
											<div class="frame">
												<h4>添加待办纪录</h4>
												<div class="projectMane_labelbox_pop">
													<div class="oh">
														<h5 class="title labelfl fl">客户名称</h5>
														<div class="labelfr fl"><el-select v-model="cusid" placeholder="请选择"><el-option v-for="item in cusoptions" :key="item.id" :label="item.customerName" :value="item.id"></el-option></el-select></div>
													</div>
													<div class="oh">
														<h5 class="title labelfl fl">待办时间</h5>
														<div class="labelfr fl"><el-date-picker v-model="addtodoTime" type="datetime"	:picker-options="pickerOptions"	placeholder="选择日期时间"	@change="dateFormat('todo',addtodoTime)"></el-date-picker></div>
													</div>
													<div class="oh">
														<h5 class="title labelfl fl">提醒时间</h5>
														<div class="labelfr fl"><el-date-picker v-model="notifyTime" type="datetime" :picker-options="pickerOptions"	placeholder="选择日期时间"	@change="dateFormat('notify',notifyTime)"></el-date-picker></div>
													</div>
													<div class="oh remarkline">
														<h5 class="title labelfl fl">备 注</h5>
														<div class="labelfr fl"><textarea class="" v-model="remark"></textarea></div>
													</div>
													<div class="oh" v-show="erromsg.length>0">
														<h5 class="title labelfl fl"></h5>
														<div class="labelfr fl"><p class="errortips redfont">{{erromsg}}</p></div>
													</div>
													<div class="oh btnbox"> 
														 <span class="basebtn fl" @click="addtodofun()">确定</span> <span class="graybtn fr" @click="addtodoframe=false">取消</span>
													</div>
												</div> 
											</div>
										</div>
									</div>
									<!-- 弹框end -->
								</div>
								<!-- 待办结束 --> 
						</div>
						<!-- 上半部分结束 -->
							<div class="workbox_bot oh whitebox">
						<!-- 部门人员数据 -->
						<div class="workbench_department_data workbench_left fl"> 
							<div class="work_title">
								<h3 class="fl title">{{viewvalue==2? '部门人员数据':'项目管理'}}</h3>
								<el-select v-model="gsvalue" v-show="viewvalue==2" @change="selectGet" class="fl">
									<el-option v-for="item in gsoptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</div> 
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="viewvalue==2">
								<tr>
									<th>所属部门</th>
									<th>姓名</th>
									<th>跟进企业总数</th>
									<th>有意向</th>
									<th>已签约</th>
									<th>已落地</th>
									<th>暂时搁浅</th>
									<th>更多</th>
								</tr>
								<tr v-for="(list,i) in tmDepartmentdata" :key="i" v-if="list.userName == crmuserdata.userName" class="selftr">
									<td><span v-show="list.departmentName !=''">{{list.departmentName}}</span><span 	v-show="list.departmentName ==''">-</span></td>
									<td>{{list.userName}}</td>
									<td>{{list.trackEnterprise}}</td>
									<td>0</td>
									<td>0</td>
									<td>0</td>
									<td>0</td>
									<td class="workbench_details" @click="routerself('/statisticalAnalysis')">详情
									</td>
								</tr>
								<tr v-for="(list,i) in tmDepartmentdata" :key="i" v-if="list.userName != crmuserdata.userName">
									<td><span v-show="list.departmentName !=''">{{list.departmentName}}</span><span 	v-show="list.departmentName ==''">-</span></td>
									<td>{{list.userName}}</td>
									<td>{{list.trackEnterprise}}</td>
									<td>0</td>
									<td>0</td>
									<td>0</td>
									<td>0</td>
									<td class="workbench_details" @click="routerself('/statisticalAnalysis')">详情
									</td>
								</tr>
							</table>
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="viewvalue == 1">
								<tr>
									<th>录入时间</th>
									<th>企业名称</th>
									<th>联系人</th>
									<th>跟进状态</th>
									<th>跟进次数</th>
									<th>最后跟进时间</th>
									<th>备注</th>
								</tr>
								<tr v-for="(item,index) in cuslist" :key="index">
									<td>{{item.enterTime}}</td>
									<td class="workbench_enterprise_details">
										<span @click="detailrouterto('/workbenchEnterpriseDetails',item.id)" :class="item.stockCode != '' ? 'curp':''">{{item.companyName}}</span>
									</td>
									<td><span v-for="(list,i) in item.contactList" :key="i"
											v-show="i<1">{{list.contactName}}</span><span
											v-show="item.contactList.length==0">暂无</span></td>
									<td>
										<span v-show="item.trackStatus == 0">-</span>
										<span v-if="item.trackStatus==1">初访{{item.trackStatus}}</span>
										<span v-if="item.trackStatus==2">有意向{{item.trackStatus}}</span>
										<span v-if="item.trackStatus==3">已签约{{item.trackStatus}}</span>
										<span v-if="item.trackStatus==4">已落地{{item.trackStatus}}</span>
										<span v-if="item.trackStatus==5">暂时搁置{{item.trackStatus}}</span>
									</td>
									<td>0</td>
									<td>
										<span v-show="item.trackTime!=0">{{item.trackTime}}</span>
										<span v-show="item.trackTime==0">-</span>
									</td>
									<td>
										<span v-if="item.remark != 0">{{item.remark}}</span>
										<span v-if="item.remark == 0">无</span>
									</td>
								</tr>
							</table> 
						</div>
						<!-- 部门项目管理数据结束-->  
							<!-- 跟进纪录 -->
							<div class="needbox2 workbench_right fr">
								<div class="oh work_title">
									<h3 class="fl title">最新跟进纪录</h3>
									<el-date-picker v-model="tracktime" type="daterange" range-separator="至"		start-placeholder="开始日期" end-placeholder="结束日期" @change="gettracklist(1)"  v-show="tracklist.length>3"></el-date-picker>
									<!-- <span class="fr add" 	@click="routerself('/followuprecord')">更多</span> -->
								</div>  
								<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" >
									<tr>
										<th>最新跟进时间 </th>
										<th>企业名称</th>
										<th v-show="viewvalue == 2">负责人</th>
										<th>备注</th>
										<th>跟进进度</th>
									</tr>
									<tr v-for="(item,i) in tracklist" :key="i"  v-if="item.managerName == crmuserdata.userName || viewvalue == 2">
										<td>{{item.contactTime}}</td>
										<td class="workbench_enterprise_details" @click="routerself('/followuprecord')"	:class="item.stockCode != '' ? 'curp':''">{{item.customerName}}</td>
											<td v-show="viewvalue == 2">{{item.managerName}}</td>
										<td><span v-show="item.remark !=''">{{item.remark}}</span><span		v-show="item.remark ==''">-</span></td> 
										<td> 
											<span v-show="item.trackStatus ==1">初访</span>
											<span v-show="item.trackStatus ==2">有意向</span>
											<span v-show="item.trackStatus ==3">已签约</span>
											<span v-show="item.trackStatus ==4">已落地</span>
											<span v-show="item.trackStatus ==5">暂时搁置</span>
										</td>
									</tr>
								</table>
								
							</div>
							<!-- 跟进纪录结束 -->
							</div>
						</div>
				
				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0"></freeUserTips>
					</div>
				</div>
				</div>
				</div>
				<!-- 右侧结束 -->
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'workbench',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				userdata: {},
				hassearch:false,
				dayarr: ['今日', '本周', '本月'],
				pickerOptions:{ 
					disabledDate(time){
						return time.getTime()<Date.now() - 8.64e7;
					}
				},
				gsoptions: [{
					value: '选项1',
					label: '全公司'
				}, {
					value: '选项2',
					label: '招商部'
				}, {
					value: '选项3',
					label: '招商部'
				}, {
					value: '选项4',
					label: '招商部'
				}, {
					value: '选项5',
					label: '招商部'
				}],
				viewoptions: [{
					value: 2,
					label: '管理视图'
				}, {
					value: 1,
					label: '个人视图'
				}],
				viewvalue: 2,
				stvalue1: '1',
				stvalue: '1', //视图value
				gsvalue: 0,
				timevalue: '', //日期选择value
				value1: '',
				tracktime: '', //最新跟进纪录时间筛选
				todotime: '', //待办纪录时间筛选 
				chartdata1: [{
						value: 0,
						name: '签约率',
						children: [{
							pname: "张强",
							value: 12,
						}, {
							pname: "刘强",
							value: 12,
						}, {
							pname: "李强",
							value: 12,
						}, ]
					},
					{
						value: 0,
						name: '落地率',
						children: [{
							pname: "张强",
							value: 12,
						}, {
							pname: "刘强",
							value: 12,
						}, {
							pname: "李强",
							value: 12,
						}, ]
					},
					{
						value: 0,
						name: '其他',
						children: [{
							pname: "张强",
							value: 12,
						}, {
							pname: "刘强",
							value: 12,
						}, {
							pname: "李强",
							value: 12,
						}, ]
					},
				],
				todolist: [], //待办列表
				tracklist: [], //跟进列表
				departmentlist: [], //部门列表
				userlist: [], //用户（人员）列表
				worklist: {}, //工作台工作统计列表
				departmentdata: [], //工作台部门数据列表
				tmDepartmentdata:[],//筛选后部门数据列表
				pagetoken: '',
				cuslist: [], //个人视图个人数据列表 
				todayopen: false, //本周本月今天隐藏显示
				addtodoframe: false,
				cusoptions: [], //客户列表
				contactoptions: [], //联系人列表
				cusid: '',
				addtodoTime: '',
				notifyTime: '',
				contactId: '',
				remark: '',
				erromsg: '', //错误提示
				userCount: [], 
				crmuserdata: {}, //crm登录信息
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
		},
		watch: { //深度 watcher 列表是否所有选中，选中则全选按钮勾选
			// 'stvalue': {
			// 	handler(val, oldVal) {
			// 		console.log(val);
			// 		if (val == 1) {
			// 			this.viewvalue = 1;
			// 			this.getanalyse('', 1);
			// 			// this.$nextTick(() => { 
			// 			// }) 
			// 		} else {
			// 			this.viewvalue = 2;
			// 		}
			// 		this.getworkcount(val);
			// 	},
			// 	deep: true
			// }
		},
		created() {
			this.userdata = this.getuseriformation();
			// this.crmlogin();
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			if(this.userdata.token){
				this.pagetoken = this.userdata.token;
				this.crmlogin();
			}
			// console.log('userdat', this.userdata, this.pagetoken);
			
		},
		methods: {
			//总体统计
			getworkcount(viewMode, date) {
					this.bus.$emit('loading', true);
				// console.log(viewMode)
				var _this = this, zhtime = '';
				// console.log(date, viewMode);
				// if (viewMode == 1 && date != '' && date != null) {
				// 	A
				// 	var time1 = _this.dateFormat('', date[0]);
				// 	var time2 = _this.dateFormat('', date[1]);
				// 	zhtime = time1 + ',' + time2;
				// 	this.todotime = time1;
				// 	this.tracktime = time1;
					// this.gettodolist(0); //初始化代办列表
					// this.gettracklist(0);//默认获取跟进列表
				// 	console.log(time1, time2, zhtime);
				// }
				// var ajaxurl= this.$api.crm.workbench.workcount()+"?viewMode="+viewMode+"&dateRange="+zhtime;
				var ajaxurl = this.$api.crm.workbench.workcount() + "?viewMode=" + viewMode; 
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) { 
							// console.log("工作统计",ajaxurl);
					if (res.data.code < 1) { 
						console.log('工作统计worklist',res.data.data)  
						_this.worklist = res.data.data;
						if(viewMode == 2){ 
							_this.departmentdata = res.data.list;//部门成员列表
							_this.tmDepartmentdata = res.data.list;//筛选后部门成员列表
							_this.userCount = res.data.extend;
						} 
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			
			
			time() {
				// console.log(this.value1[0]);
			},
			//获取待办列表
			gettodolist(type) {
				var _this = this, ntodotime = '';
				console.log('待办时间111', this.todotime);
				var ajaxurl = this.$api.crm.todo.list();
				if (type == 0) {
					console.log('xxxxx')
					ajaxurl = this.$api.crm.todo.list() + "?todoDate=" + this.todotime;
				}
				if (type == 1) { //日期选择
					if (this.todotime != null) {
						ntodotime = this.dateFormat(1, this.todotime[0]);
						ajaxurl = this.$api.crm.todo.list() + "?todoDate=" + ntodotime;
					}
					console.log('uyuyyyy')
				} else if (type == 2) { //今天
					var today = new Date();
					ntodotime = this.dateFormat(1, today)
					ajaxurl = this.$api.crm.todo.list() + "?todoDate=" + ntodotime;
					console.log(today);
				} else if (type == 3) { //本周
					var week = this.getDay(-5);
					ajaxurl = this.$api.crm.todo.list() + "?todoDate=" + week;
					console.log(week);
				} else if (type == 4) { //本月
					var month = this.getDay(-15);
					ajaxurl = this.$api.crm.todo.list() + "?todoDate=" + month;
				}
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("待办列表",ajaxurl, res.data);
					if (res.data.code < 1) {
						// console.log(ajaxurl);
						_this.todolist = res.data.list;
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},

			//获取跟进列表
			gettracklist(type) {
				var _this = this,
					ntracktime = '';
				// console.log('跟进时间111', this.tracktime);
				// console.log('类型', typeof this.tracktime);
				var ajaxurl = this.$api.crm.track.list();
				if (type == 1) {
					if (this.tracktime) {
						ntracktime = this.dateFormat(1, this.tracktime[0]);
						ajaxurl = this.$api.crm.track.list() + "?enterDate=" + ntracktime;
					}
				}
				if (type == 0) {
					ajaxurl = this.$api.crm.track.list() + "?enterDate=" + this.tracktime;
				}
				// console.log('11',ntracktime); ]
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("跟进列表", res);
					if (res.data.code < 1) {
						// console.log(ajaxurl);
						_this.tracklist = res.data.list;
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},

			//crm 用户登录权限
			crmlogin() {  
				this.crmuserdata = this.userdata.crmInfor;
				// console.log(_this.crmuserdata);
				
				this.viewvalue=this.crmuserdata.roleType>2?1:2;
				this.chartfun('work_box_right', this.chartdata1);//没有后台数据 用于美观占位
				this.gettodolist(); //待办列表
				this.gettracklist(); //跟进列表
				if(this.viewvalue == 2){
					this.getdepartmentnum(); //部门层级列表
				} 
				// this.getuserlist(); //用户列表 
				this.getworkcount(this.viewvalue); //工作统计 1个人视图 2管理视图 
				this.getcustomerlist(); //客户列表 
				 
			},


			//获取部门成员列表
			getdepartmentnum() {
				var _this = this;
				 
				// this.bus.$emit('loading', true);  
				this.$axios.get(this.$api.crm.department.list(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("部门列表", res);
					if (res.data.code < 1) { 
						_this.gsoptions = res.data.list;
						_this.gsoptions.unshift({ id: 0, 	name: "全公司"});
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},

			//用户列表
			getuserlist() {
				var _this = this;
				// this.bus.$emit('loading', true);  
				this.$axios.get(this.$api.crm.user.list(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("用户列表", res);
					if (res.data.code < 1) {
						_this.userlist = res.data.list
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},

		
			getanalyse(date, viewMode) {
				var _this = this;
				// this.bus.$emit('loading', true);  
				var ajaxurl = this.$api.crm.analyse.list() + '?dateRange=' + date + '&viewMode=' + viewMode;
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("统计分析", res.data);
					if (res.data.success) {
						// console.log(ajaxurl);
						_this.cuslist = res.data.list; //个人数据 
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//企业详情跳转
			detailrouterto(path, id) {
				let routeUrl = this.$router.resolve({
					path: path,
					query: {
						type: 2,
						id: id
					}
				});
				window.open(routeUrl.href, '_blank');
			},
			//客户列表
			getcustomerlist() {
				var _this = this;
				this.$axios.get(this.$api.crm.customer.list(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("客户列表", res);
					if (res.data.code < 1) {
						_this.cuslist = res.data.list;
						_this.cusoptions = res.data.list;
						var cusdata = res.data.list;
						var key = _this.crmuserdata.userName;
						console.log(key); //??为什么注释掉就筛选不了
						_this.cuslist = cusdata.filter(cusdata => {
							// console.log(cusdata.managerName,key);
							return cusdata.managerName.indexOf(key) == 0;
						});
						console.log('customerdata', _this.cuslist);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//修改或添加待办列表
			addtodofun() {
				// console.log(this.cusid, this.addtodoTime, this.notifyTime, this.contactId, this.remark);
				var _this = this;
				if (this.addtodoTime == '' || this.notifyTime == '') {
					this.erromsg = "时间不能为空";
					return;
				}
				if (this.contactId == '') {
					this.contactId = 0;
				}
				var datad={
						todoId: 0,
						customerId: _this.cusid,
						todoTime: _this.addtodoTime,
						notifyTime: _this.notifyTime,
						remark: _this.remark,
					};
					console.log(datad);
				$.ajax({
					type: "POST",
					url: this.$api.crm.todo.post(),
					data: datad,
					headers: {
						AuthToken: this.userdata.token
					},
					success: function(res) {
						// console.log()
						// console.log(res);
						if (res.success) {
							_this.addtodoframe = false;
							_this.gettodolist();
						}
					}
				})
			},  
			//格式化日期 （时间戳）
			dateFormat(type, date) {
				var M = date.getMonth() + 1;
				M = M < 10 ? ('0' + M) : M;
				var y = date.getFullYear();
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
				var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
				var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
				var time = y + '-' + M + '-' + d;
				var stime = y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
				console.log('time', time);
				if (type == "todo") {
					this.addtodoTime = stime;
				}
				if (type == 'notify') {
					this.notifyTime = stime;
				}
				return time;
			},
			//详情页跳转
			detailrouterto(path, id) {
				if (id == 0 || id == "") {
					return;
				}
				let routeUrl = this.$router.resolve({
					path: path,
					query: {
						id: id,
					},
				});
				window.open(routeUrl.href, '_blank');
			}, 
			//下拉框选中事件
			selectGet(vId) { //这个vId也就是value值 
				// console.log(vId,this.departmentdata);
				if(vId>0){
					this.tmDepartmentdata=this.departmentdata.filter(item=>{
						return item.departmentId==vId;
					})
				}else{
					this.tmDepartmentdata=this.departmentdata;
				} 
			},
			// 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
			getDay(day) {
				var today = new Date();
				var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
				today.setTime(targetday_milliseconds); //注意，这行是关键代码

				var tYear = today.getFullYear();
				var tMonth = today.getMonth();
				var tDate = today.getDate();
				tMonth = this.doHandleMonth(tMonth + 1);
				tDate = this.doHandleMonth(tDate);
				return tYear + "-" + tMonth + "-" + tDate;
			},
			doHandleMonth(month) {
				var m = month;
				if (month.toString().length == 1) {
					m = "0" + month;
				}
				return m;
			},
			datac() {
				console.log(this.timevalue);
			},
			chartfun(el, data) {
				var chart = echarts.init(document.getElementById(el));
				var option = {
					tooltip: {
						trigger: 'item',
						formatter: '{b}:{d}%',
						// formatter: function(params) {
						// 	console.log(params);
						// 	var result = '';
						//  result = '签约率'+ params.data.value+<br>; 
						// 	return result;
						// },
					},
					legend: {
						left: 'center',
						bottom: 'bottom',
						textStyle: {
							fontSize: 12,
							lineHeight: 100
						},
						orient: 'vertical',
						itemWidth: 6,
						itemHeight: 6,
						icon: 'rect',
						margin: 10, //图例圆形 
					},
					series: [{
						name: '签约率',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '16',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: data,
						// [
						//   { value: 1048, name: '签约率' },
						//   { value: 735, name: '落地率' },
						//   { value: 580, name: '其他' }, 
						// ]
					}],
				};
				chart.setOption(option);
			},
		}
	}
</script>

<style>
</style>
